import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { useGetRecognizeValuesQuery } from "../../api/engageApi";

// The values sheet. The list is fetched, never hardcoded, so the descriptions
// shown here always match what the server will accept.
const RecognizeValuesDialog = ({ open, selected, onClose, onSelect }) => {
  const { data: values, isLoading, isError } = useGetRecognizeValuesQuery(
    undefined,
    { skip: !open }
  );
  const [draft, setDraft] = useState(selected || []);

  useEffect(() => {
    if (open) setDraft(selected || []);
  }, [open, selected]);

  const toggle = (value) => {
    setDraft((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : prev.concat([value])
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <span className="text-lg font-semibold text-gray-800">Select</span>
      </DialogTitle>

      <DialogContent dividers>
        {isLoading && (
          <div className="flex justify-center py-8">
            <CircularProgress size={28} />
          </div>
        )}

        {isError && (
          <p className="py-6 text-sm text-red-600">
            Could not load the values list. Close this and try again.
          </p>
        )}

        {!isLoading &&
          !isError &&
          (values || []).map((item) => (
            <label
              key={item.value}
              className="flex cursor-pointer items-start gap-2 rounded-md px-1 py-1.5 hover:bg-gray-50"
            >
              <Checkbox
                size="small"
                checked={draft.includes(item.value)}
                onChange={() => toggle(item.value)}
              />
              <span className="pt-1">
                <span className="block text-sm font-semibold capitalize text-gray-800">
                  {item.value.toLowerCase()}
                </span>
                <span className="block text-xs text-gray-500">
                  {item.description}
                </span>
              </span>
            </label>
          ))}
      </DialogContent>

      <DialogActions>
        <button
          type="button"
          onClick={() => setDraft([])}
          className="rounded-md px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100"
        >
          Clear All
        </button>
        <button
          type="button"
          onClick={() => onSelect(draft)}
          className="rounded-md bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-700"
        >
          Select
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default RecognizeValuesDialog;
